import { jsx as _jsx } from "react/jsx-runtime";
const Plus = ({ size, additionalClasses = [] }) => {
    return (_jsx("svg", { className: `${size} ${additionalClasses.join(" ")}`, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: "2", "aria-label": "Add", role: "img", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 5v14m-7-7h14" }) }));
};
export default Plus;
